import { pivotActionItemsTags as pivotActionItems } from 'common/components/ActionMenu/PivotActionItems';

export interface TravelerPropertiesCount {
  name: string;
  count: number;
}

export const getUpdatedPivotActionItems = (
  pivotItems: TravelerPropertiesCount[]
) => {
  return pivotActionItems.map((item) => ({
    ...item,
    count: pivotItems.find((item2) => item2.name === item.name)?.count,
  }));
};
